import * as Constants from "../../../constants";
//import METADATA from "../../../assets/data/search.meta.json";
import {TQueryItem} from "../../../constants";

const useConvertToAdvSearch = (): { convertQuery: Function } => {
  const remapNegOne = (index: number, term: string): number => {
    return (index === -1) ? term.length + 1 : index
  }

  const convertQuery = (searchQuery: TQueryItem[], dbSet: string): TQueryItem[] => {
    searchQuery = JSON.parse(JSON.stringify(searchQuery));

    if (searchQuery.length === 1 ) {
      let terms:TQueryItem[] = [];
      const term: string = searchQuery[0].term;
      if ((term.indexOf(' AND ') !== -1) || (term.indexOf(' OR ') !== -1)) {
        let done: boolean = false;
        let newQueryItem: TQueryItem;
        let andIndex: number = -1;
        let orIndex: number = -1;
        let notIndex: number = -1;
        let termScratch: string = term;
        let operator: string | null = null;

        while (!done) {
          newQueryItem = {...searchQuery[0]}
          newQueryItem.operator = operator;
          andIndex = termScratch.indexOf(` ${Constants.AND} `);
          orIndex = termScratch.indexOf(` ${Constants.OR} `);
          notIndex = termScratch.indexOf(` ${Constants.NOT} `);

          if ((andIndex === -1) && (orIndex === -1) && (notIndex === -1)) {
            newQueryItem.term = termScratch;
            done = true;
          } else {
            const min:number = Math.min(
              remapNegOne(andIndex, newQueryItem.term),
              remapNegOne(orIndex, newQueryItem.term),
              remapNegOne(notIndex, newQueryItem.term));
            newQueryItem.term = termScratch.substring(0, min);

            switch (min) {
              case orIndex:
                operator = Constants.OR;
                break;
              case notIndex:
                operator = Constants.NOT;
                break;
              default:
                operator = Constants.AND;
            }
            termScratch = termScratch.substring(min + (` ${operator} `).length, termScratch.length);
          }
          terms.push(newQueryItem);
        }
        searchQuery = terms;
      }
    }

    return searchQuery;
  }

  return {
    convertQuery
  }
};

export default useConvertToAdvSearch;
